export default __webpack_public_path__ + "static/media/heroImg.5ce5fb39.svg";